import { jsx as _jsx } from "react/jsx-runtime";
import { Loading } from './styled';
export default function Loader() {
    return _jsx(Loading, {});
}
